import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpPlainTableComponent from './adpPlainTable.component';

let adpPlainTableModule = angular.module('adpPlainTable', [
  uiRouter
])

.component('adpPlainTable', adpPlainTableComponent)

.name;

export default adpPlainTableModule;



// WEBPACK FOOTER //
// ./src/app/components/adpPlainTable/adpPlainTable.js